// External imports
import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import Chart from "react-apexcharts";
import { Form, Button, Row, Col } from "react-bootstrap";
import { IoMdDoneAll } from "react-icons/io";

// Local imports
import { _HttpServices } from "../../../_services/_HttpServices";
import { env } from '../../../_services/env'

const barSeriesData = {
  series: [],
};

var TaskNameArray = [];
var TaskIDArray = [];
var testData = [];
const BarChart = (props, { dispatch, login }) => {
  const [barChartData, setBarChartData] = useState([]);
  const [barSeries, setBarSeries] = useState(barSeriesData);
  const [objKeys, setObjKeys] = useState(barSeriesData);
  const [dropDownList, setDropDownList] = useState([]);
  const [categories, setCategories] = useState([])
  const [colorCodes, setColorCodes] = useState(props.colorCodes)

  let barColors = []
  let intialOptions = {
    chart: {
      type: "bar",
      stacked: true,
      // stackType: '100%',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true,
      },
      events: {
        // click: clickOnChart,
      },
    },
    colors: props.barColorCodes,
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "35%",
      },
      dataLabels: {
        enabled: false,
        position: 'top',
        maxItems: 100,
        hideOverflowingLabels: false
      }
    },
    xaxis: {
      type: "category", // text
      categories: categories,
      labels: {
        show: true,
        rotate: -45,
        rotateAlways: true,
        hideOverlappingLabels: false,
        showDuplicates: true,
        trim: true,
        minHeight: undefined,
        maxHeight: 120,
      }
    },
    yaxis: {
      axisBorder: {
        show: true,
        height: 1,
        width: "1",
      },
      axisTicks: {
        show: true,
        borderType: "solid",
        height: 6,
      },
    },
    legend: {
      position: "right",
      offsetY: 0,
      borderType: "solid",
      showForSingleSeries: true,
      showForNullSeries: true,
      showForZeroSeries: true,
    },
    fill: {
      opacity: 1,
    },
    noData: {
      text: "Loading",
    },
  };
  const [barOptions, setBarOptions] = useState(intialOptions || {});
  useEffect(() => {
    setBarChartData(props.taskData);
    testData = props.taskData;
    getBarSeries();
    setDropDownList(props.dropDownData);
  }, [props, barChartData, dropDownList]);

  // Method to prepare chart options and series
  const getBarSeries = () => {
    setBarOptions({ ...barOptions, chart: { event: { click: clickOnChart } } });
    let taskNames = [];
    var StageCopyFailedCount = [];
    var ReadyForProcessCount = [];
    var QueuedForStagingCount = [];
    var ReadyForStageQueueCount = [];
    var StageCopyInProgressCount = [];
    var InProcessCount = [];
    var ProcessSuccessCount = [];
    var StageCopyCompletedCount = [];
    var ProcessFailCount = [];
    var DuplicateCount = [];
    var AcknowledgedCount = [];

    var ReadyForSendOutBoundFileCount = [];
    var FileDeliveredCount = [];
    var BatchProcessFailedCount = [];
    var TransferCopySuccessCount = [];
    var TransferCopyFailCount = [];


    if (barChartData.length > 0) {
      barChartData.map((item, index) => {
        // Pushing tasknames for to display in categories of chart
        taskNames.push(item.TaskName);

        // Pushing the relevant data count which is coming from API
        StageCopyInProgressCount.push(barChartData[index].StageCopyInProgressCount);
        StageCopyFailedCount.push(barChartData[index].StageCopyFailedCount);
        ReadyForProcessCount.push(barChartData[index].ReadyForProcessCount);
        InProcessCount.push(barChartData[index].InProcessCount);
        ProcessSuccessCount.push(barChartData[index].ProcessSuccessCount);
        ProcessFailCount.push(barChartData[index].ProcessFailCount);
        // ReadyForSendOutBoundFileCount.push(barChartData[index].ReadyForSendOutBoundFileCount);
        ReadyForStageQueueCount.push(barChartData[index].ReadyForStageQueueCount);
        QueuedForStagingCount.push(barChartData[index].QueuedForStagingCount);
        DuplicateCount.push(barChartData[index].DuplicateCount);
        AcknowledgedCount.push(barChartData[index].AcknowledgedCount);
        StageCopyCompletedCount.push(barChartData[index].StageCopyCompleted);
      });

      // Pushing the chart series data based on name
      let lSeries = [];
      let StageCopyInProgress = { name: "Stage Copy Inprogress", data: StageCopyInProgressCount };
      let StageCopyFailed = { name: "Stage Copy Failed", data: StageCopyFailedCount };
      let ReadyForProcess = { name: "Ready For Process", data: ReadyForProcessCount };
      let InProcess = { name: "Inprocess", data: InProcessCount };
      let ProcessSuccess = { name: "Process Success", data: ProcessSuccessCount };
      let ProcessFail = { name: "Process Fail", data: ProcessFailCount };
      let ReadyForSendOutBoundFile = { name: "Ready For Send Outbound File", data: ReadyForSendOutBoundFileCount };
      let ReadyForstageQueue = { name: "Ready For Stage Queue", data: ReadyForStageQueueCount };
      let Quedforstagigng = { name: "Queued For Staging", data: QueuedForStagingCount };
      let Duplicate = { name: "Duplicate", data: DuplicateCount };
      let Acknowledged = { name: "Acknowledged", data: AcknowledgedCount };
      let StageCopyCompleted = { name: "Stage Copy Completed", data: StageCopyCompletedCount };

      let FileDelivered = { name: "File Delivered", data: FileDeliveredCount };
      let BatchProcessFailed = { name: "Batch Process Failed", data: BatchProcessFailedCount };
      let TransferCopySuccess = { name: "Transfer Copy Success", data: TransferCopySuccessCount };
      let TransferCopyFail = { name: "Transfer Copy Fail", data: TransferCopyFailCount };

      lSeries.push(
        StageCopyInProgress,
        StageCopyFailed,
        ReadyForProcess,
        InProcess,
        ProcessSuccess,
        ProcessFail,
        ReadyForSendOutBoundFile,
        ReadyForstageQueue,
        Quedforstagigng,
        Duplicate,
        Acknowledged,
        StageCopyCompleted,
        FileDelivered,
        BatchProcessFailed,
        TransferCopySuccess,
        TransferCopyFail
      );
      if (lSeries.length > 0) {
        // Setting the chart series data
        barSeries.series = lSeries;
      }
      // Placing the tasknames as categories of chart
      setBarOptions({
        ...barOptions,
        xaxis: {
          categories: taskNames,
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: true,
            hideOverlappingLabels: false,
            showDuplicates: true,
            trim: true,
            minHeight: undefined,
            maxHeight: 90,
          }
        },
        dataLabels: {
          enabled: false,
          offsetX: 0,
          offsetY: 0,
        }
      });
      // setBarOptions({ ...barOptions, chart: { events: {click: clickOnChart} } });
      barOptions.chart.events.dataPointSelection = clickOnChart;
      barOptions.chart.stacked = true;
    } else {
      barSeries.series = [];
      setBarOptions({
        ...barOptions,
        noData: { text: "No records to display" },
        xaxis: { categories: [] },
      });
    }
  };

  function clickOnChart(event, chartContext, config) {
    if (env.debug) {
      console.log(chartContext.w.config.xaxis.categories[config.dataPointIndex]);
    }
    const taskName =
      chartContext.w.config.xaxis.categories[config.dataPointIndex];
    let taskId;
    let statusId;
    if (
      chartContext.w.config.series[config.seriesIndex].name ===
      "Ready For Process"
    ) {
      statusId = 3;
    }
    if (
      chartContext.w.config.series[config.seriesIndex].name ===
      "Stage Copy Inprogress"
    ) {
      statusId = 1;
    }
    if (
      chartContext.w.config.series[config.seriesIndex].name ===
      "Stage Copy Failed"
    ) {
      statusId = 2;
    }
    if (
      chartContext.w.config.series[config.seriesIndex].name ===
      "Ready For Stage Queue"
    ) {
      statusId = 8;
    }
    if (
      chartContext.w.config.series[config.seriesIndex].name ===
      "Queued For Staging"
    ) {
      statusId = 9;
    }
    if (
      chartContext.w.config.series[config.seriesIndex].name === "Inprocess"
    ) {
      statusId = 4;
    }
    if (
      chartContext.w.config.series[config.seriesIndex].name ===
      "Process Success"
    ) {
      statusId = 5;
    }
    if (
      chartContext.w.config.series[config.seriesIndex].name ===
      "Process Fail"
    ) {
      statusId = 6;
    }
    if (
      chartContext.w.config.series[config.seriesIndex].name === "Duplicate"
    ) {
      statusId = 10;
    }
    if (
      chartContext.w.config.series[config.seriesIndex].name ===
      "Acknowledged"
    ) {
      statusId = 11;
    }
    if (
      chartContext.w.config.series[config.seriesIndex].name ===
      "Stage Copy Completed"
    ) {
      statusId = 12;
    }
    if (
      chartContext.w.config.series[config.seriesIndex].name ===
      "File Delivered"
    ) {
      statusId = 13;
    }
    if (
      chartContext.w.config.series[config.seriesIndex].name ===
      "Batch Process Failed"
    ) {
      statusId = 14;
    }
    if (
      chartContext.w.config.series[config.seriesIndex].name ===
      "Ready For Send Outbound File"
    ) {
      statusId = 8;
    }
    if (taskName !== undefined && testData.length > 0) {
      testData.map((item) => {
        if (item.TaskName === taskName) {
          taskId = item.TaskId;
          // statusId = item.StatusID
        }
      });
      props.clickOnChart(taskId, statusId, props.date)
    }
  }
  return (
    <div className="bar-chart dashboard-bar-chart">
      <Row className="align-items-center">
        <Col md={6}>
          <Form.Group controlId="formLastName">
            <Form.Label>Select Task</Form.Label>
            <Form.Control
              as="select"
              name="vendorId"
              type="text"
              onChange={(e) => props.getValueFromSelect(e.target.value)}
              value={props.selectedValue}
            >
              <Fragment>
                <option value="All">All</option>
                <option value="All Inbound">All Inbound</option>
                <option value="All OutBound">All OutBound</option>
                {dropDownList.map((item) => (
                  <option key={item.Id} value={item.Id}>
                    {item.TaskName}
                  </option>
                ))}
              </Fragment>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mt-1">
            <Button type="submit" className="mt-3" hidden={true}>
              <IoMdDoneAll className="icon btn-icon" />
              Submit
            </Button>
          </Form.Group>
        </Col>
      </Row>
      <Fragment>
        {props.taskData.length > 0 && colorCodes ?
          <Chart
            options={barOptions}
            series={barSeries.series}
            type="bar"
            height={400}
            width="98%"
          /> : null
        }
        {props.taskData.length === 0 && <div className="no-data">No data found.</div>}
      </Fragment>
    </div>
  );
};

// Map Redux state to React component props
const mapStateToProps = (state) => ({
  loading: state.users.loading,
  login: state.users.login,
  users: state.users.users,
  hasErrors: state.users.hasErrors,
});

// Connect Redux to React
export default connect(mapStateToProps)(BarChart);
